export enum MediaFilter {
  Program = 'P',
  Item = 'I',
  Shot = 'S'
}
